export const GET_SIPCONFIG = 'GET_SIPCONFIG'
